import { Modal } from 'react-responsive-modal';
import React, { Suspense, useState, useEffect } from "react";
import Analysiscodes from "./Analysiscodes";
import FormatCode from "./FormatCode";
import FormatRelease from "./FormatRelease";
import MechanicalRate from "./MechanicalRate";
import SubProvider from "./SubProvider";
import Territories from "./Territories";
import ClassList from "./ClassList";
import ContractStatusListing from "./ContractStatusListing";
import ProjectStatus from "./ProjectStatus";
import AccountStatusListing from "./AccountStatus";
import AccountStatusEXTListing from "./AccountStatusExt";
import StatementStatusListing from "./StatementStatus";
import ProductStatusExtListing from "./ProductStatusExt";
import PayeeStatusListing from "./PayeeStatus";
import ProductStatusListing from "./ProductStatus";
import cachingMechanisum from "../../Common/cachingMechanisum";
import Pagination from "components/Common/newPagination";
import ColorPlatete from "components/Common/ColorPlatete";
import ThemeColorPicker from "components/Common/ColorPalete2";

export default function SystemListings() {

    const [openFirst, setOpenFirst] = useState(false);
    const [activeTab, setactiveTab] = useState("Analysis codes");
    const menu = [
        { label: 'Menu', value: 'Analysis codes' },
        { label: 'Menu', value: 'Format / Source Codes' },
        { label: 'Menu', value: 'Format Release' },
        { label: 'Menu', value: 'Mechanical Rate' },
        { label: 'Menu', value: 'MPM / Class List' },
        { label: 'Menu', value: 'Territories' },
        { label: 'Menu', value: 'Accounts/Sub Provider' },
        { label: 'Status', value: 'Contract Status' },
        { label: 'Status', value: 'Project Status' },
        { label: 'Status', value: 'Account Status' },
        { label: 'Status', value: 'Account Status Ext' },
        { label: 'Status', value: 'Statement Status' },
        { label: 'Status', value: 'Payee Status' },
        { label: 'Status', value: 'Product Status' },
        { label: 'Status', value: 'Product Status Ext' },
    ];

    useEffect(() => {
        if (openFirst) {
            var tagColorListCache = cachingMechanisum.getCachingStorage("tagColor");
            //console.log(tagColorListCache)
        }

    }, [])


    const onPageChange = (e: any) => {
        console.log(e)
    }

    return (
        <>
            <div>
                <div className={"box-primary ms text-center iconLogo pull-left  mrl"}>
                    <i className="box icon-stack2" onClick={() => { setOpenFirst(true); }}></i>
                    <span className="m0 pts ">System Listing</span>
                </div>

                <Modal open={openFirst} onClose={() => setOpenFirst(false)}  >

                    <div className='ws-12 allowHscroll allowVscroll'>

                        <div className="ws-2 pm borderReset full-height pLarge ">

                            <div className="ws-12 text-center pLarge mtll mbl"><img alt="Korrect"  className="pull-none" src="/static/media/korrectLogoIcon.2b7d4c4892ef79abbce4.png" width="50" /></div>

                            <div className="main-menu-span m0">
                                <div className="sidebar-nav">
                                    <ul className="main-menu pll prl ws-12">

                                        <a className="full-width text-bold text-average text-m mtl ws-12 pbl"> Menu</a>
                                        <ul >
                                            {
                                                menu.map((values: any) => {

                                                    if (values.label === 'Menu') {
                                                        return (<>
                                                            <li className={activeTab === values.value ? "active" : ""}
                                                                onClick={() => setactiveTab(values.value)}>
                                                                <a className="ws-12 text-sl text-normal" > {values.value} </a>
                                                            </li>
                                                        </>)
                                                    }
                                                })
                                            }
                                        </ul>

                                        <a className="full-width text-bold text-average text-m mtl ws-12 pbl"> Status</a>
                                        <ul id="mainMenu">
                                            {
                                                menu.map((values: any) => {

                                                    if (values.label === 'Status') {
                                                        return (<>
                                                            <li className={activeTab === values.value ? "active" : ""}
                                                                onClick={() => setactiveTab(values.value)}>
                                                                <a className="ws-12 text-sl text-normal" > {values.value} </a>
                                                            </li>
                                                        </>)
                                                    }
                                                })
                                            }
                                        </ul>
                                    </ul>
                                </div>

                            </div>

                        </div>

                        <div className="ws-10 pm landing">

                            <div className="ws-12 ptxl ptl pbl">
                                <span className="ws-12 text-bold text-xl">System Listing</span>
                                <span className="ws-12 ptl text-bold text-m turquoise">{activeTab}</span>
                            </div>

                            {(() => {
                                if (activeTab === "Analysis codes") {
                                    return (<div className="ws-12"> <Analysiscodes activeTab={activeTab} /> </div>);
                                }

                                if (activeTab === "Format / Source Codes") {
                                    return (<div className="ws-12"> <FormatCode activeTab={activeTab} /> </div>);
                                }

                                if (activeTab === "Format Release") {
                                    return (<div className="ws-12"> <FormatRelease activeTab={activeTab} /> </div>);
                                }

                                if (activeTab === "Mechanical Rate") {
                                    return (<div className="ws-12"> <MechanicalRate activeTab={activeTab} /> </div>);
                                }

                                if (activeTab === "MPM / Class List") {
                                    return (<div className="ws-12"> <ClassList /> </div>);
                                }

                                if (activeTab === "Territories") {
                                    return (<div className="ws-12"> <Territories activeTab={activeTab} /></div>);
                                }

                                if (activeTab === "Accounts/Sub Provider") {
                                    return (<div className="ws-12">  <SubProvider activeTab={activeTab} /> </div>);
                                }

                                if (activeTab === "Contract Status") {
                                    return (<div className="ws-12"> <ContractStatusListing activeTab={activeTab} /> </div>);
                                }

                                if (activeTab === "Project Status") {
                                    return (<div className="ws-12"> <ProjectStatus activeTab={activeTab} /> </div>);
                                }

                                if (activeTab === "Account Status") {
                                    return (<div className="ws-12"> <AccountStatusListing activeTab={activeTab} /> </div>);
                                }

                                if (activeTab === "Account Status Ext") {
                                    return (<div className="ws-12"> <AccountStatusEXTListing activeTab={activeTab} /> </div>);
                                }

                                if (activeTab === "Statement Status") {
                                    return (<div className="ws-12"> <StatementStatusListing activeTab={activeTab} /> </div>);
                                }

                                if (activeTab === "Payee Status") {
                                    return (<div className="ws-12"><PayeeStatusListing activeTab={activeTab} /> </div>);
                                }

                                if (activeTab === "Product Status") {
                                    return (<div className="ws-12"> <ProductStatusListing activeTab={activeTab} /> </div>);
                                }

                                if (activeTab === "Product Status Ext") {
                                    return (<div className="ws-12"> <ProductStatusExtListing activeTab={activeTab} /> </div>);
                                }


                            })()}


                            <div className="hide ">
                                <ColorPlatete />
                                <ThemeColorPicker />
                                <Pagination totalRow={50} onPageChange={onPageChange} />
                                <Pagination totalRow={10} onPageChange={onPageChange} />
                                <Pagination totalRow={600} onPageChange={onPageChange} />
                            </div>
                        </div>

                    </div>
                </Modal>
            </div>
        </>
    )
}